module.exports = __webpack_public_path__ + "img/6515.e62a8644.jpg";